// extracted by mini-css-extract-plugin
module.exports = {"HighlightContainer":"Highlight_HighlightContainer__3-9iu","HighlightInstance":"Highlight_HighlightInstance__1W9XE"};